import type {
  ConsumableCreateRequest,
  ConsumableGetAllRequest,
  ConsumableGetAllResponse,
  ConsumableSearchParams,
  ConsumableSearchResponse,
  ConsumableUpdateRequest,
  ConsumableUpdateResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ConsumableApi {
  public async getConsumables(
    params: ConsumableGetAllRequest,
  ): Promise<ConsumableGetAllResponse> {
    const result = await trpcClient.consumable.getAll.query(params);

    return result;
  }

  public async createConsumable(
    request: ConsumableCreateRequest,
  ): Promise<ConsumableGetAllResponse> {
    const result = await trpcClient.consumable.create.mutate(request);

    return result;
  }

  public searchConsumable = async (
    params: ConsumableSearchParams,
  ): Promise<ConsumableSearchResponse[]> => {
    const result = await trpcClient.consumable.searchConsumables.query(params);

    return result;
  };

  public async updateConsumableStatus(
    params: ConsumableUpdateRequest,
  ): Promise<ConsumableUpdateResponse> {
    const result = await trpcClient.consumable.update.mutate(params);

    return result;
  }
}
